import type { PanelItem } from '../types';
import { panelPropsGuard } from '../utils';

export class PanelsList {
  #list: PanelItem[] = [];

  push<Props extends object>(panel: PanelItem<Props>) {
    this.#list.push(panelPropsGuard(panel));
  }

  getAll() {
    return this.#list;
  }
}
